// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Header Styles - أنماط الهيدر */
.header {
  background-color: rgba(255, 255, 255, 0.92);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 1rem 0;
  border-bottom: 1px solid transparent;
  transition: padding 0.28s ease, box-shadow 0.28s ease, background-color 0.28s ease, border-color 0.28s ease;
  /* منع pull-to-refresh على Android */
  touch-action: pan-y;
  overscroll-behavior-y: contain;
}

.header.is-scrolled {
  padding: 0.65rem 0;
  background-color: rgba(255, 255, 255, 0.86);
  box-shadow: 0 8px 28px rgba(26, 54, 93, 0.12);
  border-bottom-color: rgba(212, 175, 55, 0.35);
}

.dark-mode .header {
  background-color: rgba(26, 32, 44, 0.9);
}

.dark-mode .header.is-scrolled {
  background-color: rgba(26, 32, 44, 0.94);
  border-bottom-color: rgba(212, 175, 55, 0.28);
}

/* Navbar - شريط التنقل */
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Logo - الشعار */
.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: opacity 0.3s ease;
  text-decoration: none;
  color: inherit;
}

.logo:hover {
  opacity: 0.8;
}

.logo-image {
  height: 50px;
  width: auto;
  max-width: 150px;
  object-fit: contain;
  transition: transform 0.3s ease;
  display: block;
}

.logo:hover .logo-image {
  transform: scale(1.05);
}

.logo-text {
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--primary-dark-blue);
  transition: color 0.3s ease;
}

.logo:hover .logo-text {
  color: var(--button-medium-blue);
}

/* Header Actions - أزرار الهيدر */
.header-actions {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.language-select {
  border: 2px solid var(--primary-dark-blue);
  border-radius: 999px;
  padding: 0.35rem 1rem;
  background-color: var(--bg-white);
  color: var(--text-dark-gray) !important;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 80px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-align: center;
  /* منع فتح القائمة عند الضغط على Android */
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  position: relative;
  z-index: 1000;
}

.language-select:focus {
  outline: none;
  border-color: var(--button-medium-blue);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
}

.language-select option {
  color: #111827 !important;
  background-color: #ffffff !important;
  font-weight: 600;
  font-size: 1rem;
  text-align: center;
}

.dark-mode .language-select {
  color: #f8fafc !important;
  border-color: #f8fafc;
  background-color: rgba(255, 255, 255, 0.1);
}

.dark-mode .language-select option {
  color: #f8fafc !important;
  background-color: #1f2937 !important;
}

.theme-toggle {
  background: none;
  border: 2px solid var(--primary-dark-blue);
  border-radius: 50%;
  width: 45px;
  height: 45px;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.theme-toggle:hover {
  background-color: var(--section-light-gray);
  transform: scale(1.1);
}

.dark-mode .theme-toggle {
  border-color: var(--primary-dark-blue);
  color: var(--primary-dark-blue);
}

.dark-mode .theme-toggle:hover {
  background-color: var(--section-light-gray);
}

/* Menu backdrop - طبقة إغلاق القائمة */
.nav-backdrop {
  display: none;
}

/* Navigation Links - روابط التنقل */
.nav-links {
  display: flex;
  list-style: none;
  gap: 2rem;
  align-items: center;
}

.nav-links li {
  position: relative;
}

.nav-links a {
  color: var(--text-dark-gray);
  font-weight: 500;
  font-size: 1rem;
  padding: 0.5rem 0;
  transition: color 0.3s ease;
  position: relative;
}

.nav-links a::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 2px;
  background: var(--gradient-gold);
  transition: width 0.3s ease;
}

.nav-links a:hover {
  color: var(--primary-dark-blue);
}

.nav-links a:hover::after {
  width: 100%;
}

/* Menu Toggle Button - زر القائمة (للموبايل) */
.menu-toggle {
  display: none;
  flex-direction: column;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  gap: 5px;
}

.menu-toggle span {
  width: 25px;
  height: 3px;
  background-color: var(--primary-dark-blue);
  transition: all 0.3s ease;
  border-radius: 2px;
}

.menu-toggle:hover span {
  background-color: var(--button-medium-blue);
}

/* Mobile Menu Styles - أنماط القائمة للموبايل */
@media (max-width: 768px) {
  .nav-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    top: 70px;
    border: none;
    padding: 0;
    margin: 0;
    background: rgba(10, 37, 64, 0.45);
    backdrop-filter: blur(2px);
    z-index: 998;
    cursor: pointer;
  }

  .header {
    padding: 0.75rem 0;
  }

  .navbar {
    padding: 0 15px;
  }

  .logo-image {
    height: 35px;
  }

  .logo-text {
    font-size: 1.5rem;
  }

  .menu-toggle {
    display: flex;
  }

  .nav-links {
    position: fixed;
    top: 70px;
    right: 0;
    flex-direction: column;
    background: linear-gradient(180deg, var(--bg-white) 0%, var(--section-light-gray) 100%);
    width: min(320px, 88vw);
    max-width: 320px;
    height: calc(100dvh - 70px);
    padding: 1.25rem 0 2rem;
    box-shadow: -8px 0 24px rgba(10, 37, 64, 0.18);
    gap: 0;
    z-index: 999;
    overflow-y: auto;
    transform: translateX(110%);
    transition: transform 0.28s ease;
    border-left: 3px solid var(--secondary-light-gold);
  }

  .nav-links.nav-open {
    transform: translateX(0);
  }

  body.menu-open {
    overflow: hidden;
  }

  .nav-links li {
    width: 100%;
    text-align: right;
    padding: 0;
    border-bottom: 1px solid var(--border-light);
  }

  .nav-links a {
    font-size: 1.05rem;
    font-weight: 600;
    padding: 1rem 1.5rem;
    display: block;
    width: 100%;
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
  }

  .nav-links a:active {
    background-color: rgba(37, 99, 235, 0.08);
    color: var(--button-medium-blue);
  }

  .nav-links a::after {
    display: none;
  }

  /* Animate hamburger icon when menu is open */
  .menu-toggle.active span:nth-child(1) {
    transform: rotate(45deg) translate(8px, 8px);
  }

  .menu-toggle.active span:nth-child(2) {
    opacity: 0;
  }

  .menu-toggle.active span:nth-child(3) {
    transform: rotate(-45deg) translate(7px, -7px);
  }
}

/* Ensure menu toggle works on all screen sizes */
.menu-toggle.active span {
  background-color: var(--button-medium-blue);
}

@media (max-width: 480px) {
  .logo {
    font-size: 1.5rem;
  }

  .navbar {
    padding: 0 15px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/styles/Header.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,eAAe;EACf,oCAAoC;EACpC,2GAA2G;EAC3G,oCAAoC;EACpC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,6CAA6C;EAC7C,6CAA6C;AAC/C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;EACjC,uCAAuC;EACvC,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C;EAC1C,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;EACE,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,gDAAgD;AAChD;EACE;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kCAAkC;IAClC,0BAA0B;IAC1B,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,SAAS;IACT,QAAQ;IACR,sBAAsB;IACtB,uFAAuF;IACvF,uBAAuB;IACvB,gBAAgB;IAChB,2BAA2B;IAC3B,uBAAuB;IACvB,8CAA8C;IAC9C,MAAM;IACN,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,gCAAgC;IAChC,kDAAkD;EACpD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,UAAU;IACV,4CAA4C;EAC9C;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,WAAW;IACX,0BAA0B;IAC1B,wCAAwC;EAC1C;;EAEA;IACE,yCAAyC;IACzC,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA,6CAA6C;EAC7C;IACE,4CAA4C;EAC9C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,8CAA8C;EAChD;AACF;;AAEA,iDAAiD;AACjD;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Header Styles - أنماط الهيدر */\n.header {\n  background-color: rgba(255, 255, 255, 0.92);\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  padding: 1rem 0;\n  border-bottom: 1px solid transparent;\n  transition: padding 0.28s ease, box-shadow 0.28s ease, background-color 0.28s ease, border-color 0.28s ease;\n  /* منع pull-to-refresh على Android */\n  touch-action: pan-y;\n  overscroll-behavior-y: contain;\n}\n\n.header.is-scrolled {\n  padding: 0.65rem 0;\n  background-color: rgba(255, 255, 255, 0.86);\n  box-shadow: 0 8px 28px rgba(26, 54, 93, 0.12);\n  border-bottom-color: rgba(212, 175, 55, 0.35);\n}\n\n.dark-mode .header {\n  background-color: rgba(26, 32, 44, 0.9);\n}\n\n.dark-mode .header.is-scrolled {\n  background-color: rgba(26, 32, 44, 0.94);\n  border-bottom-color: rgba(212, 175, 55, 0.28);\n}\n\n/* Navbar - شريط التنقل */\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n/* Logo - الشعار */\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n  text-decoration: none;\n  color: inherit;\n}\n\n.logo:hover {\n  opacity: 0.8;\n}\n\n.logo-image {\n  height: 50px;\n  width: auto;\n  max-width: 150px;\n  object-fit: contain;\n  transition: transform 0.3s ease;\n  display: block;\n}\n\n.logo:hover .logo-image {\n  transform: scale(1.05);\n}\n\n.logo-text {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: var(--primary-dark-blue);\n  transition: color 0.3s ease;\n}\n\n.logo:hover .logo-text {\n  color: var(--button-medium-blue);\n}\n\n/* Header Actions - أزرار الهيدر */\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.language-select {\n  border: 2px solid var(--primary-dark-blue);\n  border-radius: 999px;\n  padding: 0.35rem 1rem;\n  background-color: var(--bg-white);\n  color: var(--text-dark-gray) !important;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  min-width: 80px;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-align: center;\n  /* منع فتح القائمة عند الضغط على Android */\n  touch-action: manipulation;\n  -webkit-tap-highlight-color: transparent;\n  position: relative;\n  z-index: 1000;\n}\n\n.language-select:focus {\n  outline: none;\n  border-color: var(--button-medium-blue);\n  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);\n}\n\n.language-select option {\n  color: #111827 !important;\n  background-color: #ffffff !important;\n  font-weight: 600;\n  font-size: 1rem;\n  text-align: center;\n}\n\n.dark-mode .language-select {\n  color: #f8fafc !important;\n  border-color: #f8fafc;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.dark-mode .language-select option {\n  color: #f8fafc !important;\n  background-color: #1f2937 !important;\n}\n\n.theme-toggle {\n  background: none;\n  border: 2px solid var(--primary-dark-blue);\n  border-radius: 50%;\n  width: 45px;\n  height: 45px;\n  font-size: 1.5rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n}\n\n.theme-toggle:hover {\n  background-color: var(--section-light-gray);\n  transform: scale(1.1);\n}\n\n.dark-mode .theme-toggle {\n  border-color: var(--primary-dark-blue);\n  color: var(--primary-dark-blue);\n}\n\n.dark-mode .theme-toggle:hover {\n  background-color: var(--section-light-gray);\n}\n\n/* Menu backdrop - طبقة إغلاق القائمة */\n.nav-backdrop {\n  display: none;\n}\n\n/* Navigation Links - روابط التنقل */\n.nav-links {\n  display: flex;\n  list-style: none;\n  gap: 2rem;\n  align-items: center;\n}\n\n.nav-links li {\n  position: relative;\n}\n\n.nav-links a {\n  color: var(--text-dark-gray);\n  font-weight: 500;\n  font-size: 1rem;\n  padding: 0.5rem 0;\n  transition: color 0.3s ease;\n  position: relative;\n}\n\n.nav-links a::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 0;\n  height: 2px;\n  background: var(--gradient-gold);\n  transition: width 0.3s ease;\n}\n\n.nav-links a:hover {\n  color: var(--primary-dark-blue);\n}\n\n.nav-links a:hover::after {\n  width: 100%;\n}\n\n/* Menu Toggle Button - زر القائمة (للموبايل) */\n.menu-toggle {\n  display: none;\n  flex-direction: column;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  gap: 5px;\n}\n\n.menu-toggle span {\n  width: 25px;\n  height: 3px;\n  background-color: var(--primary-dark-blue);\n  transition: all 0.3s ease;\n  border-radius: 2px;\n}\n\n.menu-toggle:hover span {\n  background-color: var(--button-medium-blue);\n}\n\n/* Mobile Menu Styles - أنماط القائمة للموبايل */\n@media (max-width: 768px) {\n  .nav-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    top: 70px;\n    border: none;\n    padding: 0;\n    margin: 0;\n    background: rgba(10, 37, 64, 0.45);\n    backdrop-filter: blur(2px);\n    z-index: 998;\n    cursor: pointer;\n  }\n\n  .header {\n    padding: 0.75rem 0;\n  }\n\n  .navbar {\n    padding: 0 15px;\n  }\n\n  .logo-image {\n    height: 35px;\n  }\n\n  .logo-text {\n    font-size: 1.5rem;\n  }\n\n  .menu-toggle {\n    display: flex;\n  }\n\n  .nav-links {\n    position: fixed;\n    top: 70px;\n    right: 0;\n    flex-direction: column;\n    background: linear-gradient(180deg, var(--bg-white) 0%, var(--section-light-gray) 100%);\n    width: min(320px, 88vw);\n    max-width: 320px;\n    height: calc(100dvh - 70px);\n    padding: 1.25rem 0 2rem;\n    box-shadow: -8px 0 24px rgba(10, 37, 64, 0.18);\n    gap: 0;\n    z-index: 999;\n    overflow-y: auto;\n    transform: translateX(110%);\n    transition: transform 0.28s ease;\n    border-left: 3px solid var(--secondary-light-gold);\n  }\n\n  .nav-links.nav-open {\n    transform: translateX(0);\n  }\n\n  body.menu-open {\n    overflow: hidden;\n  }\n\n  .nav-links li {\n    width: 100%;\n    text-align: right;\n    padding: 0;\n    border-bottom: 1px solid var(--border-light);\n  }\n\n  .nav-links a {\n    font-size: 1.05rem;\n    font-weight: 600;\n    padding: 1rem 1.5rem;\n    display: block;\n    width: 100%;\n    touch-action: manipulation;\n    -webkit-tap-highlight-color: transparent;\n  }\n\n  .nav-links a:active {\n    background-color: rgba(37, 99, 235, 0.08);\n    color: var(--button-medium-blue);\n  }\n\n  .nav-links a::after {\n    display: none;\n  }\n\n  /* Animate hamburger icon when menu is open */\n  .menu-toggle.active span:nth-child(1) {\n    transform: rotate(45deg) translate(8px, 8px);\n  }\n\n  .menu-toggle.active span:nth-child(2) {\n    opacity: 0;\n  }\n\n  .menu-toggle.active span:nth-child(3) {\n    transform: rotate(-45deg) translate(7px, -7px);\n  }\n}\n\n/* Ensure menu toggle works on all screen sizes */\n.menu-toggle.active span {\n  background-color: var(--button-medium-blue);\n}\n\n@media (max-width: 480px) {\n  .logo {\n    font-size: 1.5rem;\n  }\n\n  .navbar {\n    padding: 0 15px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
